import type { CiSpec } from './schema';

export const ciMigrations: Record<number, (data: unknown) => CiSpec> = {
  1: (data) => data as CiSpec,
};
